export default __webpack_public_path__ + "static/media/angle-left-white.7d308b85.svg";